import { OpaccTabs } from './opacc.class.tabs.js';

/** @module article */

/**
 * Verknüpfungstypen aus dem Katalog als Tabs anzeigen
 * @extends {OpaccTabs}
 */
export class OpaccConnectTypeTabs extends OpaccTabs {
	constructor() {
		super();
	}
}